// src/components/SkipLink.jsx
import React from 'react';
import { Box } from '@mui/material';

/**
 * SkipLink - Componente de accesibilidad
 * Permite a usuarios de teclado/screen readers saltar directamente al contenido principal
 * Cumple con WCAG 2.1 Level A (Criterion 2.4.1)
 */
const SkipLink = () => {
    const handleClick = (e) => {
        e.preventDefault();
        const mainContent = document.getElementById('main-content');
        if (mainContent) {
            mainContent.focus();
            mainContent.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Box
            component="a"
            href="#main-content"
            onClick={handleClick}
            sx={{
                position: 'absolute',
                left: '-9999px',
                zIndex: 9999,
                padding: '1rem 1.5rem',
                backgroundColor: '#E50914',
                color: '#ffffff',
                textDecoration: 'none',
                fontSize: '1rem',
                fontWeight: 'bold',
                borderRadius: '0 0 4px 4px',
                '&:focus': {
                    left: '50%',
                    top: 0,
                    transform: 'translateX(-50%)',
                    outline: '3px solid #ffffff',
                    outlineOffset: '2px',
                },
            }}
        >
            Saltar al contenido principal
        </Box>
    );
};

export default SkipLink;
